export const PERMANENT = 'PERMANENT'
export const TICKET_SIDEBAR = 'TICKET_SIDEBAR'
export const TICKET_SELECTION_SIDEBAR = 'TICKET_SELECTION_SIDEBAR'
export const TICKET_SIDEBAR_TAB = 'TICKET_SIDEBAR_TAB'
